import Config, {ENV, DEPLOY_ENV} from '@/config';
import Vue from 'vue';
import VueRouter, {RouteConfig} from 'vue-router';
import addInterceptor from './interceptor';
import {postSupportTicketUrl} from '@/utils/supportMessage';
import BaseLayout from '@/layout/BaseLayout.vue';

export const routes: RouteConfig[] = [
    {
        path: '/',
        component: BaseLayout,
        children: [
            {
                path: '',
                redirect: '/ticket/list',
            },
            {
                path: '/ticket/list',
                name: 'TicketList',
                component: () => import('@/views/TicketList/index.vue'),
                meta: {
                    title: '工单列表',
                },
            },
            {
                path: '/ticket/detail',
                name: 'TicketDetail',
                component: () => import('@/views/TicketDetail/entry.vue'),
                meta: {
                    title: '工单详情',
                },
            },
            {
                path: '/ticket/create',
                name: 'CreateTicket',
                component: Config.IS_XS
                    ? () => import('@/views/TicketCreate/xsIndex.vue')
                    : () => import('@/views/TicketCreate/index.vue'),
                meta: {
                    title: '创建工单',
                },
            },
            {
                path: '/auth/list',
                name: 'AuthList',
                component: () => import('@/views/AuthList/index.vue'),
                meta: {
                    title: '服务授权',
                },
            },
        ],
    },
];

// 本地开发环境添加助手路由（辅助开发）,其他环境不添加
if (ENV === DEPLOY_ENV.development) {
    routes.push({
        path: '/ticket/assistant',
        name: 'Assistant',
        component: () => import('@/views/Znzs/index.vue'),
        meta: {},
    });
}

const getRouterPath = (name: string) => {
    const route = routes.find(item => item.name === name);
    return route ? route.path : '';
};

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

VueRouter.prototype.push = function push(location) {
    return (originalPush.call(this, location) as any).catch((err: any) => err).finally(() => {
        if (window.isSupportIframe) {
            let path = location as string;
            let query = {};
            if (typeof location !== 'string') {
                path = location.path as string;
                if (location.name) {
                    path = getRouterPath(location.name);
                }
                query = location.query as any;
            }
            postSupportTicketUrl(path, query);
        }
    });
};

VueRouter.prototype.replace = function replace(location) {
    return (originalReplace.call(this, location) as any).catch((err: any) => err);
};

Vue.use(VueRouter);

const router = new VueRouter({
    routes,
});

addInterceptor(router);

export default router;
